import {
    accessoriesFilters,
    bodiesFilters,
    displayFilters,
    hatsAndHairFilters,
    headsFilters,
    legsFilters,
} from '../filters';

const ROOT_COLLECTION_SECTIONS = {
    'hair-and-hats': 'hatsAndHair',
    'all-heads-new-1': 'heads',
    'all-torsos-new-website': 'bodies',
    'all-legs': 'legs',
    'all-displays': 'display',
    'all-accessories': 'accessories',
    // Current Shopify handle. Keep the legacy handle above because it is still
    // used by the builder's category configuration in some environments.
    'all-accessories-1': 'accessories',
};

const FILTERS_BY_SECTION = {
    hatsAndHair: hatsAndHairFilters,
    heads: headsFilters,
    bodies: bodiesFilters,
    legs: legsFilters,
    display: displayFilters,
    accessories: accessoriesFilters,
};

const addCollectionFilters = (sectionMap, filters, section) => {
    (filters || []).forEach((filter) => {
        if (filter?.filterType === 'collection' && filter?.filterHandle) {
            sectionMap.set(filter.filterHandle.toLowerCase(), section);
        }
        if (Array.isArray(filter?.subFilters)) {
            addCollectionFilters(sectionMap, filter.subFilters, section);
        }
    });
};

const builderCollectionSections = new Map(Object.entries(ROOT_COLLECTION_SECTIONS));

Object.entries(FILTERS_BY_SECTION).forEach(([section, filters]) => {
    addCollectionFilters(builderCollectionSections, filters, section);
});

export const BUILDER_COLLECTION_HANDLES = new Set(builderCollectionSections.keys());

export const getBuilderSectionFromCollections = (product) => {
    const collections = product?.collections?.edges || [];

    for (const edge of collections) {
        const handle = (edge?.node?.handle || '').toLowerCase();
        const section = builderCollectionSections.get(handle);
        if (section) return section;
    }

    return null;
};

export const isBuilderProduct = (product) => {
    const collections = product?.collections?.edges || [];
    return collections.some((edge) => BUILDER_COLLECTION_HANDLES.has((edge?.node?.handle || '').toLowerCase()));
};
